import Vue from 'vue';

import ElementUI from 'element-ui';
import App from './App.vue';
import router from './router';
import BootstrapVue from 'bootstrap-vue';

import '@/assets/scss/custom.scss';

import AppHeader from '@/components/AppHeader';
import TabBar from './components/TabBar';


const Parse = require('parse');

Parse.initialize('pdfApp', 'kh050cxa9ie277sy');
Parse.serverURL = 'http://91-250-115-40.kundenadmin.hosteurope.de:1337/parse';
Vue.prototype.$parse = Parse;

Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^ion-/];

Vue.use(ElementUI);
Vue.use(BootstrapVue);

Vue.component('app-header', AppHeader);
Vue.component('tab-bar', TabBar);

Vue.prototype.$userEventBus = new Vue();

new Vue({
    router,
    render: h => h(App),
}).$mount('#app');
